class ExtendedError extends Error {
    constructor(message, code, errorObj, results) {
        super(message, code, errorObj, results);
        this.message = message;
        this.name = "ExtendedError";
        this.code = code;
        this.errorObj = errorObj;
        this.results = results;
    }

    // Can add validation functions here, ie: //
    message(){
        return this.message;
    }
    name(){
        return this.name;
    }
    code(){
        return this.code;
    }
    errorObj(){
        return this.errorObj;
    }
    results(){
        return this.results;
    }
}
export default ExtendedError;